import type { Action } from "../actions/types";
import {
  TOGGLE_SNACKBAR
} from "../actions/types";

export type SnackBarState = {|
  type: 'SUCCESS' | 'ERROR' | 'INFO';
  msg: string;
  open: boolean;
  timeout: number;
|};

const initialState: SnackBarState = {
  type: 'SUCCESS',
  msg: '',
  open: false,
  timeout: 2000,
}

export const snackbarReducer = (state = initialState, action: Action) => {
  const { type, payload } =action;
  switch (type) {
    case TOGGLE_SNACKBAR:
      return {
        ...initialState,
        ...payload
      };

    default:
      return state;
  }
}